export class LoginModel{
    public usr: string;
    public pwd: string;

    constructor(){}
}


// WEBPACK FOOTER //
// ./src/app/login/login.model.ts